module.exports = __webpack_public_path__ + "static/media/draw-circle.b00008df.svg";